import React from "react";

import { Badge } from "../../../../components/Badge/Badge";
import {
  formatNumber,
  formatPercentageShort,
} from "../../../../utils/NumbersFormatting";
interface IProps {
  cachedItemsCount: number;
  cacheHitRatio: number;
  isLoading: boolean;
}

const Badges: React.FC<IProps> = ({
  cachedItemsCount,
  cacheHitRatio,
  isLoading,
}) => {
  const badgesData = [
    {
      variant: "primary",
      countText: !isLoading ? formatPercentageShort(cacheHitRatio) : null,
      text: "Cache hit ratio",
      tooltipText:
        "The percentage of answers coming from the cache. The higher the number, the better.",
    },

    {
      variant: "info",
      countText: !isLoading ? formatNumber(cachedItemsCount) : null,
      text: "Total cache items",
      tooltipText: "The total amount of cache items across all projects.",
    },
  ];

  return (
    <div className="d-grid grid-stats-section">
      <div className="row gy-5 g-xl-5 row-plex widget-container">
        {badgesData.map((badge: any, index: number) => (
          <div
            className="col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-xl-0"
            key={index}
          >
            <Badge
              variant={badge.variant}
              content={{
                value: badge.countText,
                title: badge.text,
                tooltipText: badge.tooltipText,
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export { Badges };
